export default __webpack_public_path__ + "static/reactnative-681666e1f099cba076a8b818ee3776bd.svg";